import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-14480">
      <span className="sr-only" data-id="element-14481">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-14482">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-14483" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-14484" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-14485">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-14486">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-14487" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-14488" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-14489" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-14490">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-14491">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-14492" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-14493" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-14494">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-14495">
            <thead data-id="element-14496">
              <tr data-id="element-14497">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-14498">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-14499" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-14500">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-14501">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-14502">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14503" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-14504">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-14505" />
          <div className="flex gap-2" data-id="element-14506">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-14507" />)}
          </div>
        </div>
      </div>
    </div>;
}